import { CLEAR_SITE_AP_CLIENTS_GRAPH, SAVE_SITE_AP_MAX_MIN_CLIENTS_GRAPH, SITE_AP_MAX_MIN_CLIENTS_GRAPH_LOADING } from "../../constants/graphConstants/customerAggrStatsGraphConstants";
/**
 * Reducer function for managing the Site Aps Max-Min Clients graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const siteApClientsGraphReducer = (state = {
    loading: false,
    clientsData: {
        min: [],
        max: [],
    }
}, action) => {
    switch (action.type) {
        case SAVE_SITE_AP_MAX_MIN_CLIENTS_GRAPH:
            return {
                ...state,
                loading: false,
                clientsData: {
                    ...state.clientsData,
                    [action.payload.usageType]: action.payload.data
                }
            };
        case SITE_AP_MAX_MIN_CLIENTS_GRAPH_LOADING:
            return {
                ...state,
                clientsData : {
                    ...state.clientsData,
                    [action.payload] : []
                },
                loading: action.payload,
            };
        case CLEAR_SITE_AP_CLIENTS_GRAPH:
            return {
                ...state,
                clientsData: {
                    ...state.clientsData,
                    [action.payload.usageType]: []
                }
            };
        default:
            return state;
    }
};